// Rails view ページ共通の JS エントリポイント。
// Vite タグは app/views/layouts/application.html.erb で読み込まれる。

// React コンポーネントを Rails view の特定の div にマウントする
import { mountComponents } from '~/mount'

mountComponents()
